module.exports = __webpack_public_path__ + "assets/GoldTau2x.6289698a9ffe17dbf67519dfaff6bcfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldTau2x.png
// module id = 823
// module chunks = 0